<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (tabledata)="getTableData()"
                   [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"
                   [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Add Status Sequence</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected">
                <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="statusSelected">
                <option *ngFor="let stat of status" [value]="stat.id">{{stat.name}}</option>
            </select>
        </div>

        <div class="form-group ticket-menu">
            <mat-checkbox class="font-13" *ngFor="let stat of statusSeq" value="{{stat.id}}"
                          [(ngModel)]="stat.checked">{{stat.name}}</mat-checkbox>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Search</div>
    </div>
    <div class="modal-body">

        <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Status"
                   [(ngModel)]="statusSelect">
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>

<ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Update Satus Flow</div>
    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected">
                <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="statusSelected">
                <option *ngFor="let stat of status" [value]="stat.id">{{stat.name}}</option>
            </select>
        </div>

        <div class="form-group ticket-menu">
            <mat-checkbox class="font-13" *ngFor="let stat of statusSeq" value="{{stat.id}}"
                          [(ngModel)]="stat.checked">{{stat.name}}</mat-checkbox>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="update()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>

<notifier-container></notifier-container>
